export const cities = [
  <select defaultValue="İstanbul" key="1" name="city">
    <option key={1} value="Adana">
      Adana
    </option>
    <option key={2} value="Adıyaman">
      Adıyaman
    </option>
    <option key={3} value="Afyonkarahisar">
      Afyonkarahisar
    </option>
    <option key={4} value="Ağrı">
      Ağrı
    </option>
    <option key={5} value="Amasya">
      Amasya
    </option>
    <option key={6} value="Ankara">
      Ankara
    </option>
    <option key={7} value="Antalya">
      Antalya
    </option>
    <option key={8} value="Artvin">
      Artvin
    </option>
    <option key={9} value="Balıkesir">
      Balıkesir
    </option>
    <option key={10} value="Aydın">
      Aydın
    </option>
    <option key={11} value="Bilecik">
      Bilecik
    </option>
    <option key={12} value="Bingöl">
      Bingöl
    </option>
    <option key={13} value="Bitlis">
      Bitlis
    </option>
    <option key={14} value="Bolu">
      Bolu
    </option>
    <option key={15} value="Burdur">
      Burdur
    </option>
    <option key={16} value="Bursa">
      Bursa
    </option>
    <option key={17} value="Çanakkale">
      Çanakkale
    </option>
    <option key={18} value="Çankırı">
      Çankırı
    </option>
    <option key={19} value="Çorum">
      Çorum
    </option>
    <option key={20} value="Denizli">
      Denizli
    </option>
    <option key={21} value="Diyarbakır">
      Diyarbakır
    </option>
    <option key={22} value="Edirne">
      Edirne
    </option>
    <option key={23} value="Elazığ">
      Elazığ
    </option>
    <option key={24} value="Erzincan">
      Erzincan
    </option>
    <option key={25} value="Erzurum">
      Erzurum
    </option>
    <option key={26} value="Eskişehir">
      Eskişehir
    </option>
    <option key={27} value="Gaziantep">
      Gaziantep
    </option>
    <option key={28} value="Giresun">
      Giresun
    </option>
    <option key={29} value="Gümüşhane">
      Gümüşhane
    </option>
    <option key={30} value="Hakkâri">
      Hakkâri
    </option>
    <option key={31} value="Hatay">
      Hatay
    </option>
    <option key={32} value="Isparta">
      Isparta
    </option>
    <option key={33} value="Mersin">
      Mersin
    </option>
    <option key={34} value="İstanbul">
      İstanbul
    </option>
    <option key={35} value="İzmir">
      İzmir
    </option>
    <option key={36} value="Kars">
      Kars
    </option>
    <option key={37} value="Kastamonu">
      Kastamonu
    </option>
    <option key={38} value="Kayseri">
      Kayseri
    </option>
    <option key={39} value="Kırklareli">
      Kırklareli
    </option>
    <option key={40} value="Kırşehir">
      Kırşehir
    </option>
    <option key={41} value="Kocaeli">
      Kocaeli
    </option>
    <option key={42} value="Konya">
      Konya
    </option>
    <option key={43} value="Kütahya">
      Kütahya
    </option>
    <option key={44} value="Malatya">
      Malatya
    </option>
    <option key={45} value="Manisa">
      Manisa
    </option>
    <option key={46} value="Kahramanmaraş">
      Kahramanmaraş
    </option>
    <option key={47} value="Mardin">
      Mardin
    </option>
    <option key={48} value="Muğla">
      Muğla
    </option>
    <option key={49} value="Muş">
      Muş
    </option>
    <option key={50} value="Nevşehir">
      Nevşehir
    </option>
    <option key={51} value="Niğde">
      Niğde
    </option>
    <option key={52} value="Ordu">
      Ordu
    </option>
    <option key={53} value="Rize">
      Rize
    </option>
    <option key={54} value="Sakarya">
      Sakarya
    </option>
    <option key={55} value="Samsun">
      Samsun
    </option>
    <option key={56} value="Siirt">
      Siirt
    </option>
    <option key={57} value="Sinop">
      Sinop
    </option>
    <option key={58} value="Sivas">
      Sivas
    </option>
    <option key={59} value="Tekirdağ">
      Tekirdağ
    </option>
    <option key={60} value="Tokat">
      Tokat
    </option>
    <option key={61} value="Trabzon">
      Trabzon
    </option>
    <option key={62} value="Tunceli">
      Tunceli
    </option>
    <option key={63} value="Şanlıurfa">
      Şanlıurfa
    </option>
    <option key={64} value="Uşak">
      Uşak
    </option>
    <option key={65} value="Van">
      Van
    </option>
    <option key={66} value="Yozgat">
      Yozgat
    </option>
    <option key={67} value="Zonguldak">
      Zonguldak
    </option>
    <option key={68} value="Aksaray">
      Aksaray
    </option>
    <option key={69} value="Bayburt">
      Bayburt
    </option>
    <option key={70} value="Karaman">
      Karaman
    </option>
    <option key={71} value="Kırıkkale">
      Kırıkkale
    </option>
    <option key={72} value="Batman">
      Batman
    </option>
    <option key={73} value="Şırnak">
      Şırnak
    </option>
    <option key={74} value="Bartın">
      Bartın
    </option>
    <option key={75} value="Ardahan">
      Ardahan
    </option>
    <option key={76} value="Iğdır">
      Iğdır
    </option>
    <option key={77} value="Yalova">
      Yalova
    </option>
    <option key={78} value="Karabük">
      Karabük
    </option>
    <option key={79} value="Kilis">
      Kilis
    </option>
    <option key={80} value="Osmaniye">
      Osmaniye
    </option>
    <option key={81} value="Düzce">
      Düzce
    </option>
  </select>,
  <div class="select_arrow"></div>
];
